import { ACTIVITY_TYPE_READ_CLAIMS } from '@/app/features/WfmActivityType/wfm-activity-type.claims';
import { authGuard } from '@/app/core/guards/auth.guard';
import { permissionGuard } from '@/app/core/guards/permission.guard';
import { AuthLayout } from '@/app/layout/components/app.authlayout';
import { LandingLayout } from '@/app/layout/components/app.landinglayout';
import { AppLayout } from '@/app/layout/components/app.layout';
import type { PageHeaderBreadcrumbSegment } from '@/app/shared/components/sub-header/sub-header.component';
import {
    _CLAIMS_EQP_CLASS_ABCS_R,
    _CLAIMS_EQP_EQUIPMENT_STATUSES_R,
    _CLAIMS_EQP_EQUIPMENT_TYPES_R,
    _CLAIMS_EQP_EQUIPMENTS_W,
    _CLAIMS_EQP_INSTALLATION_LOCATIONS_R,
    _CLAIMS_EQP_LOCATION_TYPES_R,
    _CLAIMS_EQP_MEASURE_UNITS_R,
    _CLAIMS_EQP_R
} from '@/app/shared/constants/menu-assets.claims';
import {
    claimRead as hdkClaimRead,
    claimWrite as hdkClaimWrite,
    HDK_CLAIM,
    HDK_CONFIG_CLAIM,
    HDK_ISSUE_MODULES_CLAIM,
    HDK_ISSUE_PRIORITIES_CLAIM,
    HDK_ISSUE_SPRINTS_CLAIM,
    HDK_ISSUE_STATUSES_CLAIM,
    HDK_ISSUE_TYPES_CLAIM,
    HDK_ISSUE_WORKFLOW_ROLES_CLAIM,
    HDK_ISSUE_WORKFLOWS_CLAIM,
    HDK_ISSUES_CLAIM
} from '@/app/shared/constants/hdk.claims';
import { claimRead as teamClaimRead, TEAM_CLAIM, TEAM_CONFIG_CLAIM, WFM_FIELD_TEAM_CLAIM, WFM_FIELD_TEAM_STATUSES_CLAIM } from '@/app/shared/constants/team.claims';

import type { Route, Routes } from '@angular/router';

/**
 * Builds a route for a "Mapa do Site" navigation entry that does not have a real
 * screen yet. All of these share `FeatureStubComponent`, parameterized via route
 * `data`, so the sidebar can be fully wired ahead of each feature being built.
 */
function featureStub(path: string, titleKey: string, breadcrumbParentSegments: PageHeaderBreadcrumbSegment[] = []): Route {
    return {
        path,
        loadComponent: () => import('@/app/shared/components/feature-stub/feature-stub.component').then((c) => c.FeatureStubComponent),
        canActivate: [authGuard],
        data: {
            breadcrumb: titleKey,
            breadcrumbLink: `/${path}`,
            stubTitleKey: titleKey,
            breadcrumbParentSegments
        }
    };
}

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        data: {
            breadcrumb: 'BREADCRUMB.HOME',
            breadcrumbLink: '/',
            breadcrumbLinkAria: 'BREADCRUMB.LINK_HOME_ARIA'
        },
        children: [
            // =================================================================
            // 1. HOME_MENU
            // =================================================================
            {
                path: '',
                loadComponent: () => import('@/app/features/dashboard/management/management-dashboard.component').then((c) => c.ManagementDashboardComponent),
                title: 'Painel Inicial'
            },
            {
                path: 'home',
                loadComponent: () => import('@/app/features/dashboard/management/management-dashboard.component').then((c) => c.ManagementDashboardComponent),
                title: 'Painel Inicial',
                data: { breadcrumb: 'Painel Inicial' }
            },

            // =================================================================
            // 2. ORDERS_NOTES_MENU
            // =================================================================
            {
                path: 'wo-orders',
                loadChildren: () => import('@/app/features/WoOrder/wo-order.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WO_ORDER.LIST.TITLE',
                    breadcrumbLink: '/wo-orders',
                    roleAny: ['WO-ORDERS-R', 'ADMIN', 'SYS-ADMIN', 'MENU.ORDERS_NOTES-R', 'WO-CONFIG-R' ]
                }
            },
            featureStub('wo-orders-closed', 'MENU.ORDERS_NOTES.CLOSED_ORDERS'),
            // {
            //     path: 'wo-orders-closed',
            //     loadChildren: () => import('@/app/features/WoOrder/wo-order-closed.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'WO_ORDER_CLOSED.LIST.TITLE',
            //         breadcrumbLink: '/wo-orders-closed',
            //         roleAny: ['WO-ORDERS-CLOSED-R', 'ADMIN', 'SYS-ADMIN', 'MENU.ORDERS_NOTES-R', 'WO-CONFIG-R']
            //     }
            // },
            featureStub('wo-technical-notes', 'MENU.ORDERS_NOTES.TECHNICAL_NOTES'),
            // {
            //     path: 'wo-technical-notes',
            //     loadChildren: () => import('@/app/features/WoOrder/wo-technical-notes.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'WO_TECHNICAL_NOTES.LIST.TITLE',
            //         breadcrumbLink: '/wo-technical-notes',
            //         roleAny: ['WO-TECHNICAL-NOTES-R', 'ADMIN', 'SYS-ADMIN', 'MENU.ORDERS_NOTES-R', 'WO-CONFIG-R']
            //     }
            // },
            {
                path: 'wo-order-controls',
                loadChildren: () => import('@/app/features/WoOrderControl/wo-order-control.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WO_ORDER_CONTROL.LIST.TITLE',
                    breadcrumbLink: '/wo-order-controls',
                    roleAny: ['WO-ORDER-CONTROLS-R', 'ADMIN', 'SYS-ADMIN', 'MENU.ORDERS_NOTES-R', 'WO-CONFIG-R']
                }
            },
            featureStub('wo-closure-validation', 'MENU.ORDERS_NOTES.CLOSURE_VALIDATION'),
            // {
            //     path: 'wo-closure-validation',
            //     loadChildren: () => import('@/app/features/WoOrder/wo-closure-validation.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'WO_CLOSURE_VALIDATION.LIST.TITLE',
            //         breadcrumbLink: '/wo-closure-validation',
            //         roleAny: ['WO-CLOSURE-VALIDATION-R', 'ADMIN', 'SYS-ADMIN', 'MENU.ORDERS_NOTES-R', 'WO-CONFIG-R']
            //     }
            // },

            // =================================================================
            // 3. OPERATIONAL_PLANNING_MENU
            // =================================================================
            {
                path: 'wfm-planning-policies',
                loadChildren: () => import('@/app/features/Wfm/WfmPriorizationPlanning/wfm-priorization-planning.routes'),
                canActivate: [authGuard],
                data: { 
                    breadcrumb: 'WFM_PRIORIZATION_PLANNING.TITLE', 
                    breadcrumbLink: '/wfm-planning-policies',
                    roleAny: ['WO-ORDER-CONTROLS-R', 'ADMIN', 'SYS-ADMIN', 'MENU.OPERATIONAL_PLANNING-R']
                 }
            },
            {
                path: 'wfm-prioritization-policies',
                loadChildren: () => import('@/app/features/Wfm/WfmPrioritizationPolicies/wfm-prioritization-policies.routes'),
                canActivate: [authGuard],
                data: {
                    breadcrumb: 'PM_CENARIO_PRIORIZACAO.TITLE',
                    breadcrumbLink: '/wfm-prioritization-policies',
                    roleAny: ['WO-ORDER-CONTROLS-R', 'ADMIN', 'SYS-ADMIN', 'MENU.OPERATIONAL_PLANNING-R']
                }
            },
            {
                path: 'field-teams',
                loadChildren: () => import('@/app/features/Team/WfmFieldTeam/wfm-field-team.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WFM_FIELD_TEAM.LIST.TITLE',
                    breadcrumbLink: '/field-teams',
                    breadcrumbLinkAria: 'WFM_FIELD_TEAM.LIST.LINK_ARIA',
                    roleAny: [teamClaimRead(WFM_FIELD_TEAM_CLAIM), teamClaimRead(TEAM_CLAIM)]
                }
            },
            {
                path: 'wfm-schedules',
                loadChildren: () => import('@/app/features/WfmSchedule/wfm-schedule.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WFM_SCHEDULE.BREADCRUMB',
                    breadcrumbLink: '/wfm-schedules',
                    roleAny: ['WFM-SCHEDULES-R', 'WFM-SCHEDULES-W']
                }
            },
            {
                path: 'wfm-service-assignment',
                loadChildren: () => import('@/app/features/WfmServiceAssignment/wfm-service-assignment.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WFM_SERVICE_ASSIGNMENT.TITLE',
                    breadcrumbLink: '/wfm-service-assignment',
                    roleAny: ['WFM-SERVICE-ASSIGNMENT-R', 'WFM-SERVICE-ASSIGNMENT-W']
                }
            },
            featureStub('wfm-planning-exceptions', 'MENU.OPERATIONAL_PLANNING.EXCEPTIONS'),
            // {
            //     path: 'wfm-planning-exceptions',
            //     loadChildren: () => import('@/app/features/Wfm/WfmPlanningExceptions/wfm-planning-exceptions.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'WFM_PLANNING_EXCEPTIONS.LIST.TITLE',
            //         breadcrumbLink: '/wfm-planning-exceptions',
            //         roleAny: ['WFM-PLANNING-EXCEPTIONS-R']
            //     }
            // },
            featureStub('wfm-plan-consolidation', 'MENU.OPERATIONAL_PLANNING.CONSOLIDATION'),
            // {
            //     path: 'wfm-plan-consolidation',
            //     loadChildren: () => import('@/app/features/Wfm/WfmPlanConsolidation/wfm-plan-consolidation.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'WFM_PLAN_CONSOLIDATION.LIST.TITLE',
            //         breadcrumbLink: '/wfm-plan-consolidation',
            //         roleAny: ['WFM-PLAN-CONSOLIDATION-R']
            //     }
            // },
            featureStub('wfm-planning-history', 'MENU.OPERATIONAL_PLANNING.HISTORY'),
            // {
            //     path: 'wfm-planning-history',
            //     loadChildren: () => import('@/app/features/Wfm/WfmPlanningHistory/wfm-planning-history.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'WFM_PLANNING_HISTORY.LIST.TITLE',
            //         breadcrumbLink: '/wfm-planning-history',
            //         roleAny: ['WFM-PLANNING-HISTORY-R']
            //     }
            // },

            // =================================================================
            // 4. ASSETS_MENU
            // =================================================================
            {
                path: 'consultas/objetos-tecnicos',
                loadChildren: () =>
                    import('@/app/features/Eqp/TechnicalObject/routes/technical-object-consultation.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'UC_PM_02.LIST.TITLE',
                    breadcrumbLink: '/consultas/objetos-tecnicos',
                    breadcrumbLinkAria: 'UC_PM_02.BREADCRUMB.LINK_ARIA',
                    roleAny: [_CLAIMS_EQP_R, _CLAIMS_EQP_INSTALLATION_LOCATIONS_R]
                }
            },
            {
                path: 'eqp-installation-locations',
                loadChildren: () => import('@/app/features/Eqp/EqpInstallationLocations/eqp-installation-locations.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'BREADCRUMB.EQP_INSTALLATION_LOCATION_LIST',
                    breadcrumbLink: '/eqp-installation-locations',
                    roleAny: [_CLAIMS_EQP_INSTALLATION_LOCATIONS_R, _CLAIMS_EQP_R]
                }
            },
            {
                path: 'aux-tables',
                loadChildren: () => import('@/app/features/AuxTables/aux-tables.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'MENU.CONFIGURATION.AUXILIARY_TABLES',
                    breadcrumbLink: '/configuracao/tabelas-auxiliares',
                    roleAny: ['WFM-NOTE-TYPES-R', 'WO-ORDER-TYPES-R', ...ACTIVITY_TYPE_READ_CLAIMS, 'EQP-EQUIPMENT-TYPES-R', 'EQP-R', 'WFM-PRIORITIES-R', 'WFM-CONSEQUENCES-R']
                }
            },

            // =================================================================
            // 5. MATERIALS_MENU
            // =================================================================
            featureStub('wo-material-reservations', 'MENU.MATERIALS.RESERVATIONS'),
            // {
            //     path: 'wo-material-reservations',
            //     loadChildren: () => import('@/app/features/WoMaterial/wo-material-reservations.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.MATERIALS.RESERVATIONS',
            //         breadcrumbLink: '/wo-material-reservations'
            //     }
            // },
            featureStub('wo-material-balance', 'MENU.MATERIALS.BALANCE'),
            // {
            //     path: 'wo-material-balance',
            //     loadChildren: () => import('@/app/features/WoMaterial/wo-material-balance.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.MATERIALS.BALANCE',
            //         breadcrumbLink: '/wo-material-balance'
            //     }
            // },
            featureStub('wo-material-monitor', 'MENU.MATERIALS.MONITOR'),
            // {
            //     path: 'wo-material-monitor',
            //     loadChildren: () => import('@/app/features/WoMaterial/wo-material-monitor.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.MATERIALS.MONITOR',
            //         breadcrumbLink: '/wo-material-monitor'
            //     }
            // },
            featureStub('wo-stock-control', 'MENU.MATERIALS.STOCK_CONTROL'),
            // {
            //     path: 'wo-stock-control',
            //     loadChildren: () => import('@/app/features/WoMaterial/wo-stock-control.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.MATERIALS.STOCK_CONTROL',
            //         breadcrumbLink: '/wo-stock-control'
            //     }
            // },
            featureStub('wo-materials-applied', 'MENU.MATERIALS.APPLIED'),
            // {
            //     path: 'wo-materials-applied',
            //     loadChildren: () => import('@/app/features/WoMaterial/wo-materials-applied.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.MATERIALS.APPLIED',
            //         breadcrumbLink: '/wo-materials-applied'
            //     }
            // },
            featureStub('wo-materials', 'MENU.MATERIALS.CATALOG.MATERIALS'),
            // {
            //     path: 'wo-materials',
            //     loadChildren: () => import('@/app/features/WoMaterial/wo-materials.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.MATERIALS.CATALOG.MATERIALS',
            //         breadcrumbLink: '/wo-materials'
            //     }
            // },
            featureStub('wo-material-groups', 'MENU.MATERIALS.CATALOG.GROUPS'),
            // {
            //     path: 'wo-material-groups',
            //     loadChildren: () => import('@/app/features/WoMaterial/wo-material-groups.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.MATERIALS.CATALOG.GROUPS',
            //         breadcrumbLink: '/wo-material-groups'
            //     }
            // },
            featureStub('wo-material-kits', 'MENU.MATERIALS.CATALOG.KITS'),
            // {
            //     path: 'wo-material-kits',
            //     loadChildren: () => import('@/app/features/WoMaterial/wo-material-kits.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.MATERIALS.CATALOG.KITS',
            //         breadcrumbLink: '/wo-material-kits'
            //     }
            // },
            featureStub('wo-warehouses', 'MENU.MATERIALS.CATALOG.WAREHOUSES'),
            // {
            //     path: 'wo-warehouses',
            //     loadChildren: () => import('@/app/features/WoMaterial/wo-warehouses.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.MATERIALS.CATALOG.WAREHOUSES',
            //         breadcrumbLink: '/wo-warehouses'
            //     }
            // },
            featureStub('wo-material-operations', 'MENU.MATERIALS.CATALOG.OPERATIONS'),
            // {
            //     path: 'wo-material-operations',
            //     loadChildren: () => import('@/app/features/WoMaterial/wo-material-operations.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.MATERIALS.CATALOG.OPERATIONS',
            //         breadcrumbLink: '/wo-material-operations'
            //     }
            // },

            // =================================================================
            // 6. MONITORING_MENU
            // =================================================================
            featureStub('wfm-team-tracking', 'MENU.MONITORING.TEAM_TRACKING'),
            // {
            //     path: 'wfm-team-tracking',
            //     loadChildren: () => import('@/app/features/Wfm/WfmTeamTracking/wfm-team-tracking.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.MONITORING.TEAM_TRACKING',
            //         breadcrumbLink: '/wfm-team-tracking'
            //     }
            // },
            {
                path: 'gantt',
                loadChildren: () => import('@/app/features/Gantt/gantt.routes'),
                canActivate: [authGuard, permissionGuard],
                title: 'GANTT.TITLE',
                data: {
                    breadcrumb: 'GANTT.BREADCRUMB',
                    breadcrumbLink: '/gantt',
                    breadcrumbLinkAria: 'GANTT.BREADCRUMB_LINK_ARIA',
                    roleAny: ['WFM-GANTT-R', 'WFM-GANTT-W', 'MONITORING-R', 'MONITORING-W', 'SYS-ADMIN']
                }
            },
            featureStub('wfm-daily-production', 'MENU.MONITORING.DAILY_PRODUCTION'),
            // {
            //     path: 'wfm-daily-production',
            //     loadChildren: () => import('@/app/features/Wfm/WfmDailyProduction/wfm-daily-production.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.MONITORING.DAILY_PRODUCTION',
            //         breadcrumbLink: '/wfm-daily-production'
            //     }
            // },
            featureStub('wfm-sla-alerts', 'MENU.MONITORING.SLA_ALERTS'),
            // {
            //     path: 'wfm-sla-alerts',
            //     loadChildren: () => import('@/app/features/Wfm/WfmSlaAlerts/wfm-sla-alerts.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.MONITORING.SLA_ALERTS',
            //         breadcrumbLink: '/wfm-sla-alerts'
            //     }
            // },
            {
                path: 'monitor-dashboard',
                loadChildren: () => import('@/app/features/dashboard/monitor/monitor-dashboard.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'MONITOR_DASHBOARD.LIST.TITLE',
                    breadcrumbLink: '/monitor-dashboard',
                    breadcrumbLinkAria: 'MONITOR_DASHBOARD.LIST.LINK_ARIA',
                    roleAny: ['INTEGRATION-API-DOCS-R', 'SYS-ADMIN']
                }
            },

            // =================================================================
            // 7. ANALYTICS_MENU
            // =================================================================
            featureStub('wfm-management-dashboards', 'MENU.ANALYTICS.MANAGEMENT_DASHBOARDS'),
            // {
            //     path: 'wfm-management-dashboards',
            //     loadChildren: () => import('@/app/features/Wfm/WfmManagementDashboards/wfm-management-dashboards.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.ANALYTICS.MANAGEMENT_DASHBOARDS',
            //         breadcrumbLink: '/wfm-management-dashboards'
            //     }
            // },
            featureStub('wfm-operational-reports', 'MENU.ANALYTICS.OPERATIONAL_REPORTS'),
            // {
            //     path: 'wfm-operational-reports',
            //     loadChildren: () => import('@/app/features/Wfm/WfmOperationalReports/wfm-operational-reports.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.ANALYTICS.OPERATIONAL_REPORTS',
            //         breadcrumbLink: '/wfm-operational-reports'
            //     }
            // },
            featureStub('wfm-indexes', 'MENU.ANALYTICS.INDEXES'),
            // {
            //     path: 'wfm-indexes',
            //     loadChildren: () => import('@/app/features/Wfm/WfmIndexes/wfm-indexes.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.ANALYTICS.INDEXES',
            //         breadcrumbLink: '/wfm-indexes'
            //     }
            // },

            // =================================================================
            // 8. SETTINGS_MENU
            // =================================================================
            // --- Services ---
            featureStub('wo-execution-flows', 'MENU.SETTINGS.SERVICES.EXECUTION_FLOWS'),
            // {
            //     path: 'wo-execution-flows',
            //     loadChildren: () => import('@/app/features/Wo/ExecutionFlows/wo-execution-flows.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.SETTINGS.SERVICES.EXECUTION_FLOWS',
            //         breadcrumbLink: '/wo-execution-flows'
            //     }
            // },
            {
                path: 'wo-order-statuses',
                loadChildren: () => import('@/app/features/WoOrderStatus/wo-order-status.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WO_ORDER_STATUS.LIST.TITLE',
                    breadcrumbLink: '/wo-order-statuses',
                    roleAny: ['WO-CONFIG-R', 'WO-ORDER-STATUSES-R']
                }
            },
            {
                path: 'ckl-templates',
                loadChildren: () => import('@/app/features/CklChecklist/ckl-checklist.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'CKL.TEMPLATE.LIST.TITLE',
                    breadcrumbLink: '/ckl-templates',
                    roleAny: ['CKL-TEMPLATES-R', 'SEC-ADM-R']
                }
            },
            {
                path: 'ckl-layout-items',
                loadChildren: () => import('@/app/features/CklChecklist/ckl-layout-item.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'CKL.LAYOUT_ITEM.LIST.TITLE',
                    breadcrumbLink: '/ckl-layout-items',
                    roleAny: ['CKL-LAYOUT-ITEMS-R', 'SEC-ADM-R']
                }
            },
            {
                path: 'wo-service-characteristics',
                loadChildren: () => import('@/app/features/WoServiceCharacteristic/wo-service-characteristic.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WO_SERVICE_CHARACTERISTIC.LIST.TITLE',
                    breadcrumbLink: '/wo-service-characteristics',
                    roleAny: ['WO-CONFIG-R', 'WO-ORDER-TYPES-R']
                }
            },
            {
                path: 'wo-service-classes',
                loadChildren: () => import('@/app/features/WoServiceClass/wo-service-class.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WO_SERVICE_CLASS.LIST.TITLE',
                    breadcrumbLink: '/wo-service-classes',
                    roleAny: ['WO-CONFIG-R', 'WO-ORDER-TYPES-R']
                }
            },
            {
                path: 'fluxo-servicos',
                loadChildren: () => import('@/app/features/Wo/OrderFlow/order-flow.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WF_ORDER_FLOW.LIST.TITLE',
                    breadcrumbLink: '/fluxo-servicos',
                    roleAny: ['WF-ORDER-FLOWS-R', 'WF-ORDER-FLOWS-W', 'SETTINGS_SERVICES-R', 'SETTINGS_SERVICES-W', 'WO-CONFIG-R', 'SYS-ADMIN']
                }
            },
            {
                path: 'wo-service-config',
                loadChildren: () => import('@/app/features/WoServiceConfiguration/wo-service-configuration.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'MENU.SETTINGS.SERVICES.SERVICE_CONFIG',
                    breadcrumbLink: '/wo-service-config',
                    roleAny: ['WO-SERVICE-CONFIGURATIONS-R', 'WO-R']
                }
            },
            {
                path: 'configuracao-servico',
                loadChildren: () => import('@/app/features/WoServiceConfiguration/wo-service-configuration.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'MENU.SETTINGS.SERVICES.SERVICE_CONFIG',
                    breadcrumbLink: '/configuracao-servico',
                    roleAny: ['WO-SERVICE-CONFIGURATIONS-R', 'WO-R']
                }
            },

            // --- Contractors ---
            {
                path: 'sec-contractor-companies',
                loadChildren: () => import('@/app/features/SecContractorCompany/sec-contractor-company.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'SEC_CONTRACTOR_COMPANY.LIST.TITLE',
                    breadcrumbLink: '/sec-contractor-companies',
                    roleAny: ['SEC-CONTRACTOR-COMPANIES-R', 'SEC-R']
                }
            },
            {
                path: 'wfm-contractor-personnel-import',
                loadComponent: () => import('@/app/features/Importacao/pages/file-import.component').then((c) => c.FileImportComponent),
                data: { type: 'employees', breadcrumb: 'MENU.SETTINGS.CONTRACTORS.PERSONNEL_IMPORT' }
            },
            {
                path: 'wfm-contractor-employees-import',
                loadComponent: () => import('@/app/features/Importacao/pages/file-import.component').then((c) => c.FileImportComponent),
                data: { type: 'contractor-employees', breadcrumb: 'MENU.SETTINGS.CONTRACTORS.EMPLOYEES_IMPORT' }
            },
            {
                path: 'wfm-contractor-status-import',
                loadComponent: () => import('@/app/features/Importacao/pages/file-import.component').then((c) => c.FileImportComponent),
                data: { type: 'absence-reasons', breadcrumb: 'MENU.SETTINGS.CONTRACTORS.STATUS_IMPORT' }
            },
            {
                path: 'wfm-contractor-schedules-import',
                loadComponent: () => import('@/app/features/Importacao/pages/file-import.component').then((c) => c.FileImportComponent),
                data: { type: 'contractor-schedules', breadcrumb: 'MENU.SETTINGS.CONTRACTORS.SCHEDULES_IMPORT' }
            },
            {
                path: 'wfm-contractor-shifts-import',
                loadComponent: () => import('@/app/features/Importacao/pages/file-import.component').then((c) => c.FileImportComponent),
                data: { type: 'shifts', breadcrumb: 'MENU.SETTINGS.CONTRACTORS.SHIFT_IMPORT' }
            },

            // --- Organization ---
            {
                path: 'organization-structures',
                loadChildren: () => import('@/app/features/SecOrganizationStructure/sec-organization-structure.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'SEC_ORGANIZATION_STRUCTURE.LIST.TITLE',
                    breadcrumbLink: '/organization-structures',
                    breadcrumbLinkAria: 'BREADCRUMB.LINK_ORGANIZATION_STRUCTURE_LIST_ARIA',
                    role: ['SEC-ORGANIZATION-STRUCTURES-R']
                }
            },
            {
                path: 'employees',
                loadChildren: () => import('@/app/features/WfmEmployee/wfm-employee.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WFM_EMPLOYEE.LIST.TITLE',
                    breadcrumbLink: '/employees',
                    breadcrumbLinkAria: 'WFM_EMPLOYEE.LIST.LINK_ARIA',
                    roleAny: ['WFM-EMPLOYEES-R', 'WFM_EMPLOYEE_R']
                }
            },
            {
                path: 'employee-positions',
                loadChildren: () => import('@/app/features/WfmEmployeePosition/wfm-employee-position.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'MENU.SETTINGS.POSITIONS.EMPLOYEES',
                    breadcrumbLink: '/employee-positions',
                    breadcrumbLinkAria: 'WFM_EMPLOYEE_POSITION.LIST.LINK_ARIA',
                    role: ['WFM-EMPLOYEE-POSITIONS-R']
                }
            },
            featureStub('wfm-vehicles', 'MENU.SETTINGS.ORGANIZATION.VEHICLES'),
            // {
            //     path: 'wfm-vehicles',
            //     loadChildren: () => import('@/app/features/Wfm/WfmVehicles/wfm-vehicles.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.SETTINGS.ORGANIZATION.VEHICLES',
            //         breadcrumbLink: '/wfm-vehicles'
            //     }
            // },
            featureStub('wfm-projects', 'MENU.SETTINGS.ORGANIZATION.PROJECTS'),
            // {
            //     path: 'wfm-projects',
            //     loadChildren: () => import('@/app/features/Wfm/WfmProjects/wfm-projects.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.SETTINGS.ORGANIZATION.PROJECTS',
            //         breadcrumbLink: '/wfm-projects'
            //     }
            // },

            // --- Calendar ---
            {
                path: 'utl-holidays',
                loadChildren: () => import('@/app/features/Holidays/utl-holidays.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'UTL_HOLIDAY.BREADCRUMB.LIST',
                    breadcrumbLink: '/utl-holidays',
                    role: ['UTL-HOLIDAYS-R']
                }
            },
            featureStub('utl-holidays-locations', 'MENU.SETTINGS.CALENDAR.HOLIDAYS_BY_LOCATION', [
                { labelKey: 'MENU.SETTINGS.ROOT' },
                { labelKey: 'MENU.SETTINGS.CALENDAR.ROOT' }
            ]),
            // {
            //     path: 'utl-holidays-locations',
            //     loadChildren: () => import('@/app/features/Holidays/utl-holidays-locations.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.SETTINGS.CALENDAR.HOLIDAYS_BY_LOCATION',
            //         breadcrumbLink: '/utl-holidays-locations'
            //     }
            // },

            // =================================================================
            // 9. ADMIN_MENU
            // =================================================================
            // --- Users ---
            {
                path: 'users',
                loadChildren: () => import('@/app/features/SecUser/sec-user.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'BREADCRUMB.USER_LIST',
                    breadcrumbLink: '/users',
                    breadcrumbLinkAria: 'BREADCRUMB.LINK_USER_LIST_ARIA',
                    role: ['SEC-USERS-R']
                }
            },
            {
                path: 'roles',
                loadChildren: () => import('@/app/features/SecRole/sec-role.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'BREADCRUMB.ROLE_LIST',
                    breadcrumbLink: '/roles',
                    breadcrumbLinkAria: 'BREADCRUMB.LINK_ROLE_LIST_ARIA',
                    role: ['SEC-ROLES-R']
                }
            },
            {
                path: 'claims',
                loadChildren: () => import('@/app/features/SecClaim/sec-claim.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'SEC_CLAIM.LIST.TITLE',
                    breadcrumbLink: '/claims',
                    role: ['SEC-CLAIMS-R']
                }
            },

            // --- Licenses ---
            featureStub('sec-license-config', 'MENU.ADMIN.LICENSES.CONFIG'),
            // {
            //     path: 'sec-license-config',
            //     loadChildren: () => import('@/app/features/LicenseConfig/license-config.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.ADMIN.LICENSES.CONFIG',
            //         breadcrumbLink: '/sec-license-config'
            //     }
            // },
            {
                path: 'license-control',
                loadChildren: () => import('@/app/features/LicenseControl/license-control.routes'),
                canActivate: [authGuard, permissionGuard],
                data: { breadcrumb: 'Controle de Licenças', role: ['LICENSE-CONTROL-R'] }
            },

            // --- Messages ---
            featureStub('sec-user-messages', 'MENU.ADMIN.MESSAGES'),
            // {
            //     path: 'sec-user-messages',
            //     loadChildren: () => import('@/app/features/SecUserMessages/sec-user-messages.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.ADMIN.MESSAGES',
            //         breadcrumbLink: '/sec-user-messages'
            //     }
            // },

            // --- System ---
            {
                path: 'company-detail',
                loadChildren: () => import('@/app/features/SecCompany/sec-company.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    role: ['SEC-COMPANIES-R']
                }
            },
            {
                path: 'employee-roles',
                loadChildren: () => import('@/app/features/WfmEmployeeRole/wfm-employee-role.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WFM_EMPLOYEE_ROLE.LIST.TITLE',
                    breadcrumbLink: '/employee-roles',
                    breadcrumbLinkAria: 'WFM_EMPLOYEE_ROLE.LIST.LINK_ARIA',
                    role: ['WFM-EMPLOYEE-ROLES-R']
                }
            },
            {
                path: 'employee-shifts',
                loadChildren: () => import('@/app/features/WfmEmployeeShift/wfm-employee-shift.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WFM_EMPLOYEE_SHIFT.LIST.TITLE',
                    breadcrumbLink: '/employee-shifts',
                    breadcrumbLinkAria: 'WFM_EMPLOYEE_SHIFT.LIST.LINK_ARIA',
                    role: ['WFM-EMPLOYEE-SHIFTS-R']
                }
            },
            {
                path: 'skills',
                loadChildren: () => import('@/app/features/WfmSkill/wfm-skill.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WFM_SKILL.LIST.TITLE',
                    breadcrumbLink: '/skills',
                    breadcrumbLinkAria: 'WFM_SKILL.LIST.LINK_ARIA',
                    role: ['WFM-SKILLS-R']
                }
            },
            {
                path: 'employee-statuses',
                loadChildren: () => import('@/app/features/WfmEmployeeStatus/wfm-employee-status.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WFM_EMPLOYEE_STATUS.LIST.TITLE',
                    breadcrumbLink: '/employee-statuses',
                    breadcrumbLinkAria: 'WFM_EMPLOYEE_STATUS.LIST.LINK_ARIA',
                    role: ['WFM-EMPLOYEE-STATUSES-R']
                }
            },
            {
                path: 'field-team-statuses',
                loadChildren: () => import('@/app/features/Team/WfmFieldTeamStatus/wfm-field-team-status.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WFM_FIELD_TEAM_STATUS.LIST.TITLE',
                    roleAny: [teamClaimRead(WFM_FIELD_TEAM_STATUSES_CLAIM), teamClaimRead(TEAM_CONFIG_CLAIM)]
                }
            },
            featureStub('wfm-order-checklists-items', 'MENU.SETTINGS.SERVICES.SERVICE_FLOW'),
            // {
            //     path: 'wfm-order-checklists-items',
            //     loadChildren: () => import('@/app/features/Wfm/WfmOrderChecklistsItems/wfm-order-checklists-items.routes'),
            //     canActivate: [authGuard, permissionGuard],
            //     data: {
            //         breadcrumb: 'MENU.SETTINGS.SERVICES.SERVICE_FLOW',
            //         breadcrumbLink: '/wfm-order-checklists-items',
            //         roleAny: ['WF-ORDER-FLOWS-R', 'SYS-ADMIN']
            //     }
            // },
            {
                path: 'wf-flow-types',
                loadChildren: () => import('@/app/features/Wo/FlowType/flow-type.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WF_FLOW_TYPE.LIST.TITLE',
                    breadcrumbLink: '/wf-flow-types',
                    roleAny: ['WF-FLOW-TYPES-R', 'WO-CONFIG-R']
                }
            },

            // =================================================================
            // 10. HELP_MENU
            // =================================================================
            featureStub('help-documentation', 'MENU.HELP.DOCUMENTATION'),
            // {
            //     path: 'help-documentation',
            //     loadChildren: () => import('@/app/features/Help/HelpDocumentation/help-documentation.routes'),
            //     canActivate: [authGuard],
            //     data: {
            //         breadcrumb: 'MENU.HELP.DOCUMENTATION',
            //         breadcrumbLink: '/help-documentation'
            //     }
            // },
            featureStub('help-changelog', 'MENU.HELP.CHANGELOG'),
            // {
            //     path: 'help-changelog',
            //     loadChildren: () => import('@/app/features/Help/HelpChangelog/help-changelog.routes'),
            //     canActivate: [authGuard],
            //     data: {
            //         breadcrumb: 'MENU.HELP.CHANGELOG',
            //         breadcrumbLink: '/help-changelog'
            //     }
            // },
            {
                path: 'hdk-issues',
                loadChildren: () => import('@/app/features/Hdk/HdkIssue/hdk-issue.routes').then((m) => m.HDK_ISSUE_ROUTES),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'HDK_ISSUE.LIST.TITLE',
                    breadcrumbLink: '/hdk-issues',
                    breadcrumbLinkAria: 'HDK_ISSUE.LIST.LINK_ARIA',
                    roleAny: [hdkClaimRead(HDK_ISSUES_CLAIM), hdkClaimRead(HDK_CLAIM)]
                }
            },
            {
                path: 'integration-api-docs',
                loadChildren: () => import('@/app/features/dashboard/integration/integration-api-docs.routes')
            },

            // =================================================================
            // ADDITIONAL / NON-MENU / UTILITY ROUTES
            // =================================================================
            {
                path: 'dashboard-banking',
                loadComponent: () => import('@/app/pages/dashboards/banking/bankingdashboard').then((c) => c.BankingDashboard),
                title: 'DASHBOARD.TITLE',
                data: { breadcrumb: 'Banking Dashboard' }
            },
            {
                path: 'dashboard-marketing',
                loadComponent: () => import('@/app/pages/dashboards/marketing/marketingdashboard').then((c) => c.MarketingDashboard),
                title: 'DASHBOARD.TITLE',
                data: { breadcrumb: 'Marketing Dashboard' }
            },
            {
                path: 'uikit',
                data: { breadcrumb: 'UI Kit' },
                loadChildren: () => import('@/app/pages/uikit/uikit.routes')
            },
            {
                path: 'documentation',
                data: { breadcrumb: 'Documentation' },
                loadComponent: () => import('@/app/pages/documentation/documentation').then((c) => c.Documentation)
            },
            {
                path: 'pages',
                loadChildren: () => import('@/app/pages/pages.routes'),
                data: { breadcrumb: 'Pages' }
            },
            {
                path: 'apps',
                loadChildren: () => import('@/app/apps/apps.routes'),
                data: { breadcrumb: 'Apps' }
            },
            {
                path: 'blocks',
                data: { breadcrumb: 'Free Blocks' },
                loadChildren: () => import('@/app/pages/blocks/blocks.routes')
            },
            {
                path: 'ecommerce',
                loadChildren: () => import('@/app/pages/ecommerce/ecommerce.routes'),
                data: { breadcrumb: 'E-Commerce' }
            },
            {
                path: 'profile',
                loadChildren: () => import('@/app/pages/usermanagement/usermanagement.routes')
            },
            {
                path: 'hdk',
                children: [
                    {
                        path: 'workflows',
                        redirectTo: '/workflows',
                        pathMatch: 'full'
                    }
                ]
            },
            {
                path: 'workflows',
                loadChildren: () => import('@/app/features/Hdk/HdkIssueWorkflow/hdk-issue-workflow.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'MENU.HELP.TRANSITION_FLOW',
                    breadcrumbLink: '/workflows',
                    breadcrumbLinkAria: 'ISSUE_WORKFLOW.LIST.LINK_ARIA',
                    roleAny: [
                        hdkClaimRead(HDK_ISSUE_WORKFLOWS_CLAIM),
                        hdkClaimRead(HDK_ISSUE_WORKFLOW_ROLES_CLAIM),
                        hdkClaimRead(HDK_CONFIG_CLAIM),
                        hdkClaimWrite(HDK_ISSUE_WORKFLOWS_CLAIM),
                        hdkClaimWrite(HDK_ISSUE_WORKFLOW_ROLES_CLAIM),
                        hdkClaimWrite(HDK_CONFIG_CLAIM)
                    ]
                }
            },
            {
                path: 'issue-workflows',
                redirectTo: '/workflows',
                pathMatch: 'full'
            },
            {
                path: 'equipment-types',
                loadChildren: () => import('@/app/features/Eqp/EqpEquipmentType/eqp-equipment-type.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'EQP_EQUIPMENT_TYPE.LIST.TITLE',
                    breadcrumbLink: '/equipment-types',
                    breadcrumbLinkAria: 'EQP_EQUIPMENT_TYPE.BREADCRUMB.LINK_ARIA',
                    roleAny: [_CLAIMS_EQP_EQUIPMENT_TYPES_R, _CLAIMS_EQP_R]
                }
            },
            {
                path: 'eqp-class-abcs',
                loadChildren: () => import('./app/features/Eqp/EqpClassABC/eqp-class-abc.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'EQP_CLASS.LIST.TITLE',
                    breadcrumbLink: '/eqp-class-abcs',
                    roleAny: [_CLAIMS_EQP_CLASS_ABCS_R, _CLAIMS_EQP_R]
                }
            },
            {
                path: 'equipment-statuses',
                loadChildren: () => import('@/app/features/Eqp/EqpEquipmentStatus/eqp-equipment-status.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'EQP_EQUIPMENT_STATUS.LIST.TITLE',
                    breadcrumbLink: '/equipment-statuses',
                    breadcrumbLinkAria: 'EQP_EQUIPMENT_STATUS.BREADCRUMB.LINK_ARIA',
                    roleAny: [_CLAIMS_EQP_EQUIPMENT_STATUSES_R, _CLAIMS_EQP_R]
                }
            },
            {
                path: 'measure-units',
                loadChildren: () => import('@/app/features/Eqp/EqpMeasureUnit/eqp-measure-unit.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'EQP_MEASURE_UNIT.LIST.TITLE',
                    breadcrumbLink: '/measure-units',
                    breadcrumbLinkAria: 'EQP_MEASURE_UNIT.BREADCRUMB.LINK_ARIA',
                    roleAny: [_CLAIMS_EQP_MEASURE_UNITS_R, _CLAIMS_EQP_R]
                }
            },
            {
                path: 'equipments',
                loadChildren: () => import('@/app/features/Eqp/EqpEquipment/eqp-equipment.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'EQP_EQUIPMENT.LIST.TITLE',
                    breadcrumbLink: '/equipments',
                    breadcrumbLinkAria: 'EQP_EQUIPMENT.BREADCRUMB.LINK_ARIA',
                    roleAny: [_CLAIMS_EQP_R, _CLAIMS_EQP_EQUIPMENTS_W]
                }
            },
            {
                path: 'equipment-locations',
                loadChildren: () => import('@/app/features/Eqp/EqpInstallationLocations/eqp-installation-locations.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'MNT.EQUIPMENT_LOCATIONS.LIST.TITLE',
                    breadcrumbLink: '/equipment-locations',
                    breadcrumbLinkAria: 'MNT.EQUIPMENT_LOCATIONS.BREADCRUMB.LINK_ARIA',
                    roleAny: ['EQP-EQUIPMENT-LOCATIONS-R', 'SYS-ADMIN']
                }
            },
            {
                path: 'integration-monitor',
                loadChildren: () => import('@/app/features/IntegrationMonitor/integration-monitor.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'INTEGRATION_MONITOR.LIST.TITLE',
                    breadcrumbLink: '/integration-monitor',
                    breadcrumbLinkAria: 'INTEGRATION_MONITOR.LIST.LINK_ARIA',
                    roleAny: ['INT-EXECUTION-LOGS-R', 'SYS-ADMIN']
                }
            },
            {
                path: 'importacao',
                loadChildren: () => import('@/app/features/Importacao/importacao.routes'),
                canActivate: [authGuard, permissionGuard],
                data: { breadcrumb: 'Importação', roleAny: ['IMP-FILE-W', 'SYS-ADMIN'] }
            },
            {
                path: 'employee-start-points',
                loadChildren: () => import('@/app/features/WfmEmployeeStartPoint/wfm-employee-start-point.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WFM_EMPLOYEE_START_POINT.LIST.TITLE',
                    breadcrumbLink: '/employee-start-points',
                    breadcrumbLinkAria: 'WFM_EMPLOYEE_START_POINT.LIST.LINK_ARIA',
                    role: ['WFM-EMPLOYEE-STARTPOINTS-R']
                }
            },
            {
                path: 'field-team-types',
                redirectTo: 'field-teams',
                pathMatch: 'full'
            },
            {
                path: 'wo-order-types',
                loadChildren: () => import('@/app/features/WoOrderType/wo-order-type.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WO_ORDER_TYPE.LIST.TITLE',
                    breadcrumbLink: '/wo-order-types',
                    role: ['WO-ORDER-TYPES-R']
                }
            },
            {
                path: 'wfm-activity-types',
                loadChildren: () => import('@/app/features/WfmActivityType/wfm-activity-type.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WFM_ACTIVITY_TYPE.LIST.TITLE',
                    breadcrumbLink: '/wfm-activity-types',
                    role: ACTIVITY_TYPE_READ_CLAIMS
                }
            },
            {
                path: 'wfm-priorities',
                loadChildren: () => import('@/app/features/WfmPriority/wfm-priority.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WFM_PRIORITY.LIST.TITLE',
                    breadcrumbLink: '/wfm-priorities',
                    role: ['WFM-PRIORITIES-R']
                }
            },
            {
                path: 'wfm-consequences',
                loadChildren: () => import('@/app/features/WfmConsequence/wfm-consequence.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WFM_CONSEQUENCE.LIST.TITLE',
                    breadcrumbLink: '/wfm-consequences',
                    role: ['WFM-CONSEQUENCES-R']
                }
            },
            {
                path: 'wfm-note-types',
                loadChildren: () => import('@/app/features/WfmNoteType/wfm-note-type.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'WFM_NOTE_TYPE.LIST.TITLE',
                    breadcrumbLink: '/wfm-note-types',
                    role: ['WFM-NOTE-TYPES-R']
                }
            },
            {
                path: 'eqp-location-types',
                loadChildren: () => import('@/app/features/EqpLocationType/eqp-location-type.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'BREADCRUMB.EQP_LOCATION_TYPE_LIST',
                    breadcrumbLink: '/eqp-location-types',
                    roleAny: [_CLAIMS_EQP_LOCATION_TYPES_R, _CLAIMS_EQP_R]
                }
            },
            {
                path: 'hdk-issue-statuses',
                loadChildren: () => import('@/app/features/Hdk/HdkIssueStatus/hdk-issue-status.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'HDK_ISSUE_STATUS.LIST.TITLE',
                    breadcrumbLink: '/hdk-issue-statuses',
                    roleAny: [hdkClaimRead(HDK_ISSUE_STATUSES_CLAIM), hdkClaimRead(HDK_CONFIG_CLAIM)]
                }
            },
            {
                path: 'hdk-issue-priorities',
                loadChildren: () => import('@/app/features/Hdk/HdkIssuePriority/hdk-issue-priority.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'HDK_ISSUE_PRIORITY.LIST.TITLE',
                    breadcrumbLink: '/hdk-issue-priorities',
                    roleAny: [hdkClaimRead(HDK_ISSUE_PRIORITIES_CLAIM), hdkClaimRead(HDK_CONFIG_CLAIM)]
                }
            },
            {
                path: 'hdk-issue-modules',
                loadChildren: () => import('@/app/features/Hdk/HdkIssueModule/hdk-issue-module.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'HDK_ISSUE_MODULE.LIST.TITLE',
                    breadcrumbLink: '/hdk-issue-modules',
                    roleAny: [hdkClaimRead(HDK_ISSUE_MODULES_CLAIM), hdkClaimRead(HDK_CONFIG_CLAIM)]
                }
            },
            {
                path: 'hdk-issue-sprints',
                loadChildren: () => import('@/app/features/Hdk/HdkIssueSprint/hdk-issue-sprint.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'HDK_ISSUE_SPRINT.LIST.TITLE',
                    breadcrumbLink: '/hdk-issue-sprints',
                    roleAny: [hdkClaimRead(HDK_ISSUE_SPRINTS_CLAIM), hdkClaimRead(HDK_CONFIG_CLAIM)]
                }
            },
            {
                path: 'hdk-issue-types',
                loadChildren: () => import('@/app/features/Hdk/HdkIssueType/hdk-issue-type.routes'),
                canActivate: [authGuard, permissionGuard],
                data: {
                    breadcrumb: 'HDK_ISSUE_TYPE.LIST.TITLE',
                    breadcrumbLink: '/hdk-issue-types',
                    roleAny: [hdkClaimRead(HDK_ISSUE_TYPES_CLAIM), hdkClaimRead(HDK_CONFIG_CLAIM)]
                }
            },
            featureStub('sec-access-config', 'MENU.ADMIN.USERS.ACCESS_CONFIG'),
            {
                path: 'no-access',
                loadComponent: () => import('@/app/features/auth/access/access.component').then((m) => m.AccessComponent),
                title: 'MENU.AUTH_ACCESS_DENIED'
            },
            {
                path: 'not-found',
                loadComponent: () => import('@/app/pages/notfound/notfound').then((c) => c.Notfound),
                title: 'MENU.AUTH_ERROR'
            }
        ]
    },
    {
        path: 'landing',
        component: LandingLayout,
        children: [
            {
                path: '',
                loadComponent: () => import('@/app/pages/landing/landingpage').then((c) => c.LandingPage)
            },
            {
                path: 'features',
                loadComponent: () => import('@/app/pages/landing/featurespage').then((c) => c.FeaturesPage)
            },
            {
                path: 'pricing',
                loadComponent: () => import('@/app/pages/landing/pricingpage').then((c) => c.PricingPage)
            },
            {
                path: 'contact',
                loadComponent: () => import('@/app/pages/landing/contactpage').then((c) => c.ContactPage)
            }
        ]
    },

    { path: 'notfound', redirectTo: '/not-found', pathMatch: 'full' },
    {
        path: 'auth',
        component: AuthLayout,
        loadChildren: () => import('@/app/features/auth/auth.routes').then((m) => m.authRoutes)
    },
    { path: '**', redirectTo: '/not-found' }
];
